import { h } from 'preact'
import { useState } from 'preact/hooks'
import { tagParser } from '../../js/modules/utilities.js'

export const TuileDevice = ({ tag, DAS, image, brand, model, capacity, color, from_price, price_without_promo, price, CTA: { URL, analytics }, sr_only, price_small = false }) => {
   const [tooltip, setTooltip] = useState(false)
   const toggleTooltip = (e) => {
      e.preventDefault()
      setTooltip((prevTooltip) => !prevTooltip)
   }

   return (
      <div class="tuile-device">
         <a
            href={URL}
            data-pdb-zid={analytics.pdbZid}
            data-pdb-sc={analytics.pdbSc}
            data-pdb-idc={analytics.pdbIdc}
            data-pdb-vi={analytics.pdbVi}
            data-oevent-category={analytics.oeventCategory}
            data-oevent-action={analytics.oeventAction}
            data-oevent-label={analytics.oeventLabel}
            data-oevent-other={analytics.oeventOther}
         >
            {tag && (
               <div class="tag">
                  <div class="ob1-tag ob1-tag-primary">{tag}</div>
               </div>
            )}

            <div class="content-top">
               <img class="image" src={image} alt="" loading="lazy" />
            </div>

            <div class="content-bottom">
               <h3 class="model-parent h4">
                  <span class="brand">{brand}</span>
                  <span class="model">{model}</span>
                  <span class="description">
                     <span class="capacity">{capacity}</span>
                     <ColorDisc hex={color} />
                  </span>
               </h3>

               <div class="price ob1-price text-right" data-ob1-component="Price">
                  <span class="sr-only">{sr_only}</span>
                  <p aria-hidden="true">
                     {from_price === true && <span class="ob1-price-from">à partir de</span>}
                     {from_price === false && price_without_promo !== '' ? <s class="ob1-price-without-promo">{price_without_promo}</s> : null}
                     <span class={`ob1-price-amount ${price_small ? 'price-small' : ''}`}>{price}</span>
                  </p>
               </div>
            </div>
         </a>

         {DAS && (
            <div class={`das text-dark ob1-tooltip ${tooltip && 'active'}`}>
               <span tabindex="0" class="ob1-tooltip-trigger picto-das btn" onClick={toggleTooltip}>
                  <span class="icon icon-info text-dark" aria-hidden="true"></span>
                  <strong class="text-dark">DAS</strong>
               </span>

               <div class="ob1-tooltip-content ob1-tooltip-bottom" id="tooltip-content-bottom">
                  <span dangerouslySetInnerHTML={{ __html: tagParser(DAS) }}></span>
               </div>
               <div class="ob1-tooltip-shadow"></div>
            </div>
         )}
      </div>
   )
}

export const ColorDisc = ({ hex }) => {
   // Remove the '#' character if present
   const rgb = hex.replace(/^#/, '')

   // Check if the HEX code is valid
   if (rgb.length !== 6) {
      return null
   }

   // Convert HEX values to RGB
   const r = parseInt(rgb.substring(0, 2), 16)
   const g = parseInt(rgb.substring(2, 4), 16)
   const b = parseInt(rgb.substring(4, 6), 16)

   // Calculate the border color based on brightness
   const luminosity = (r * 299 + g * 587 + b * 114) / 1000
   const borderColor = luminosity > 128 ? '#ccc' : '#fff'

   return <span class="device-color" style={{ background: hex, borderColor }}></span>
}
